export default "__VITE_ASSET__Bu44vX33__"